var _linearGradient, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 488 248",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e33e44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ec6370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f07140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ee927f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d192b1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m291.773282 168.581649c-9.099801 5.691811-16.233382 5.568925-22.904663.628376-5.294823-3.921185-9.04961-9.062274-17.032007-22.06301l-.009056-.01475c-.962241-1.567178-1.395762-2.271551-1.935914-3.142921-.602283-.971601-1.893221-1.280148-2.88339-.68916-.99017.590989-1.304614 1.857717-.702331 2.829318.536055.864761.967527 1.565804 1.926718 3.128016l.009056.01475c8.289133 13.50031 12.202278 18.858223 18.098637 23.224888 8.100391 5.998903 17.141225 6.154644 27.688906-.442797.97729-.611283 1.264527-1.884217.641562-2.84318-.622965-.958962-1.920228-1.240812-2.897518-.62953z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.343843 117.012866c-.546014.897118-.985874 1.62507-1.955929 3.234398l-.025973.04309c-8.0101686 13.288921-11.789935 18.558106-17.1096927 22.56687-6.7005108 5.049246-13.8670245 5.170988-23.0094607-.654962-.9823214-.625977-2.286105-.337103-2.9120821.645218-.6259771.982322-.337103 2.286105.6452184 2.912082 10.5962764 6.7524 19.6779657 6.598123 27.8149053.46644 5.9252881-4.465068 9.8651059-9.957373 18.1837498-23.758056l.025974-.043091c.966952-1.604181 1.404715-2.328663 1.946558-3.218927.605597-.995015.289912-2.292567-.705103-2.898165-.995015-.605597-2.292567-.289912-2.898165.705103z",
    fill: "#000",
    transform: "matrix(-1 0 0 1 167.254874 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108 89.8536585h136.379897c1.656854 0 3 1.3431458 3 3v122.0000005c0 1.656854-1.343146 3-3 3h-136.379897c-1.656854 0-3-1.343146-3-3v-122.0000005c0-1.6568542 1.343146-3 3-3z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.343434 189.07184h104.423435c1.294243 0 2.343434-.944272 2.343434-2.109091 0-1.164818-1.049191-2.10909-2.343434-2.10909h-104.423435c-1.294243 0-2.343434.944272-2.343434 2.10909 0 1.164819 1.049191 2.109091 2.343434 2.109091z",
    fill: "#000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.343434 203.07184h57.554748c1.294243 0 2.343434-.944272 2.343434-2.109091 0-1.164818-1.049191-2.10909-2.343434-2.10909h-57.554748c-1.294243 0-2.343434.944272-2.343434 2.10909 0 1.164819 1.049191 2.109091 2.343434 2.109091z",
    fill: "#000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.379897 94.981523h-142.379897",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)",
    stroke: "#000",
    strokeWidth: 4,
    transform: "matrix(.99254615 .12186934 -.12186934 .99254615 103.79439 8.1055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m158 70.1570681c0-38.6599325-33.578644-70.00000004-75-70.00000004-41.4213562 0-75 35.35729904-75 70.00000004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104 69.1570681c0-38.1076478-9.6258779-69.00000004-21.5-69.00000004s-21.5 34.85219484-21.5 69.00000004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.2238622 63.1620842 77.9187628 5.5707839c.523278.0374116.987622.2738319 1.321146.6320527s.536229.838242.536229 1.3628553v9.429292c0 .5522847-.223858 1.0522847-.585786 1.4142135-.361929.3619288-.861929.5857865-1.414214.5857865h-157c-.55228475 0-1.05228475-.2238577-1.41421356-.5857865s-.58578644-.8619288-.58578644-1.4142135v-9.4246611c0-.5250905.20306203-1.0054631.53707398-1.3637622.33401196-.3582991.79897382-.5945247 1.32277349-.6313211z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m287.181836 79.9764959c-.000004 3.8623105-.00001 9.6557762-.000018 17.3803971 0 .8771698.667537 1.5958057 1.51424 1.6593239l.122124.0045638h17.181818c.86266 0 1.569408-.6787645 1.631875-1.5397098l.004489-.1241779c.000313-7.8501208.000547-13.6085198.000704-17.2751972.000023-.5314071 1.328527-.3157862 1.93309.3068962 3.349946 3.4503496 5.429842 8.5052549 5.429842 13.6405256 0 8.3777784-5.535701 15.4408774-13.090701 17.6137474-.000055 6.620408-.000097 11.585714-.000124 14.895918-.000108 12.882238-.000269 32.205595-.000484 57.97007 4.797752 2.036264 8.182218 6.968396 8.182218 12.729428 0 3.837663-1.501839 7.307506-3.922842 9.79854-.555476.571544-1.804545.632997-1.80454.17316.000024-2.678124.000061-6.695311.000109-12.05156 0-.87717-.667536-1.595806-1.51424-1.659324l-.122123-.004564h-11.454546c-.862659 0-1.569408.678765-1.631875 1.53971l-.004488.124178c-.000282 5.412759-.000493 9.472328-.000633 12.178708-.000022.417454-1.007263.475502-1.467432.034177-2.61749-2.510299-4.259208-6.120624-4.259208-10.133025 0-6.083031 3.773372-11.241915 8.999597-13.043364l.000919-72.337677c-7.970507-1.883276-13.909607-9.150457-13.909607-17.8281224 0-5.5875114 2.462361-10.5902339 6.343884-13.9474218.581925-.5033157 1.837953-.5352716 1.837952-.1051999z",
    fill: "#6d7278",
    stroke: "#000",
    strokeWidth: 4,
    transform: "matrix(.96592583 .25881905 -.25881905 .96592583 47.306422 -71.973575)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 120,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 120,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.412484 146.941899c1.055836-.324476 2.1748.268408 2.499276 1.324244.324476 1.055835-.268408 2.174799-1.324244 2.499275-6.943429 2.133833-14.078151 3.201064-21.397568 3.201064-7.302196 0-14.873726-1.06214-22.712126-3.182194-1.066257-.288391-1.696842-1.38655-1.408452-2.452807.288391-1.066257 1.386551-1.696843 2.452808-1.408452 7.506843 2.030377 14.728611 3.043453 21.66777 3.043453 6.921939 0 13.660585-1.007985 20.222536-3.024583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.83383135 3.40178153 19.58849785 107.49639247c.2094835 1.149589 1.3093162 1.911346 2.456545 1.701431 1.1472289-.209914 1.9074217-1.31201 1.6979382-2.461598l-19.58849782-107.49639289c-.2094835-1.14958891-1.30931617-1.91134557-2.45654504-1.70143114-1.14722886.20991444-1.90742169 1.31200966-1.69793819 2.46159856z",
    transform: "translate(48 63)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.98480775 -.17364818 .17364818 .98480775 .050948 14.432079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.2399915 6.78398643 30.9787618 49.56601887c1.4635517 2.3416827.7516858 5.4264346-1.5899968 6.8899862-.794658.4966613-1.7128961.7600085-2.6499947.7600085h-61.95752359c-2.76142375 0-5-2.2385763-5-5 0-.9370986.26334722-1.8553367.76000848-2.6499947l30.97876181-49.56601887c1.4635516-2.34168265 4.5483035-3.05354848 6.8899862-1.58999682.6438457.40240354 1.1875933.94615116 1.5899968 1.58999682z",
    fill: "#eaaa00"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.756686 3.56859914c.4763112.30446811.8794612.71290139 1.1799908 1.19545462l33.2191133 53.33912934c1.1141813 1.789014.5858814 4.1543556-1.1799908 5.2831382-.6038952.3860225-1.30335.5908903-2.0174036.5908903h-66.43822664c-2.08799055 0-3.78064133-1.714833-3.78064133-3.8301867 0-.7234113.20221778-1.4320326.58324687-2.0438418l33.2191133-53.33912934c1.1141813-1.789014 3.4489259-2.32423727 5.2147981-1.19545462zm-1.6139229 2.59143712c-.3279477-.20963107-.7539969-.13230601-.991603.16628693l-.0513566.07280399-33.21911333 53.33912932c-.07620582.1223619-.11664938.2640861-.11664938.4087684 0 .3928514.2918959.7166334.66794774.7608837l.08818053.0051536h66.43822664c.1428107 0 .2827017-.0409735.4034807-.118178.3279477-.2096311.4424773-.6325055.2787503-.9783235l-.0427521-.0783042-33.2191133-53.33912932c-.0450795-.07238298-.1017037-.13642747-.1673871-.18961528z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.1214007 46.2548986.5510204-24.18h-5.632653l.4897959 24.18zm-2.2653061 8.82c.8571429 0 1.5714286-.28 2.1428571-.84.5714286-.56.8571429-1.26.8571429-2.1s-.2857143-1.54-.8571429-2.1c-.5714285-.56-1.2857142-.84-2.1428571-.84s-1.5714286.28-2.1428571.84c-.5714286.56-.8571429 1.26-.8571429 2.1s.2857143 1.54.8571429 2.1c.5714285.56 1.2857142.84 2.1428571.84z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5,
    transform: "translate(338.168497 11.173442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.8899646 15.5555556-6.0889964 6.0704607-6.0889965-6.0704607-6.0889965 6.0704607-6.0889964-6.0704607-6.0716532 6.0704607-6.1063398-6.0704607-6.0889964 6.0704607-6.0889965-6.0704607-6.08899644 6.0704607-6.08899646-6.0704607",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.496556 15.5555556-6.088997 6.0704607-6.088996-6.0704607-6.088997 6.0704607-6.0889963-6.0704607",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.3958295 0-4.5667474 4.55284553 9.1334947 8.52324697-9.1334947 8.5499238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.3958295 0-4.5667474 4.55284553 9.1334947 8.52324697-9.1334947 8.5499238",
    transform: "matrix(-1 0 0 1 156.791658 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.8290821 43.2520325 9.1334947 8.523247-9.1334947 8.5499238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.8290821 43.2520325 9.1334947 8.523247-9.1334947 8.5499238",
    transform: "matrix(-1 0 0 1 156.791658 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.8290821 63.7398374 9.1334947 8.5232469-9.1334947 8.5499238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.8290821 63.7398374 9.1334947 8.5232469-9.1334947 8.5499238",
    transform: "matrix(-1 0 0 1 156.791658 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.8290821 84.2276423 9.1334947 8.5232469-9.1334947 8.5499238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.8290821 84.2276423 9.1334947 8.5232469-9.1334947 8.5499238",
    transform: "matrix(-1 0 0 1 156.791658 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.829082 104.783198 9.133495 8.523247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.829082 104.783198 9.133495 8.523247",
    transform: "matrix(-1 0 0 1 156.791658 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m338.168498 32.799458v-6.070461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.257494 32.799458v-6.070461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.346491 32.799458v-6.070461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.435487 32.799458v-6.070461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.524483 32.799458v-6.070461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.61348 32.799458v-6.070461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.702476 32.799458v-6.070461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.791473 32.799458v-6.070461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.880469 32.799458v-6.070461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.969466 32.799458v-6.070461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.058462 32.799458v-6.070461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.309067 32.799458v-6.070461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.398064 32.799458v-6.070461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.48706 32.799458v-6.070461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.576057 32.799458v-6.070461"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(330 7)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 1.03523,
    rx: 0.5,
    strokeWidth: 2,
    width: 143.374791,
    x: 1,
    y: 26.243902
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.16849749 19.7289973h61.27052691l5.7431208 6.0704607h-73.86376873z",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.7022901 31.5555556v12.8888888",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#122632",
    height: 1.53523,
    rx: 0.5,
    strokeWidth: 1.5,
    width: 12.907001,
    x: 80.110827,
    y: 45.316396
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.6474586 31.8699187h15.0281139c.2761424 0 .5.2238576.5.5v11.6964772c0 .2761424-.2238576.5-.5.5h-18.0281139c-.2761424 0-.5-.2238576-.5-.5v-8.6964772c0-1.9329966 1.5670033-3.5 3.5-3.5z",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#122632",
    height: 1.53523,
    rx: 0.5,
    strokeWidth: 1.5,
    width: 12.907001,
    x: 80.110827,
    y: 65.248645
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#122632",
    height: 1.53523,
    rx: 0.5,
    strokeWidth: 1.5,
    width: 12.907001,
    x: 80.110827,
    y: 85.73645
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#122632",
    height: 1.53523,
    rx: 0.5,
    strokeWidth: 1.5,
    width: 12.907001,
    x: 80.110827,
    y: 106.224255
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.440379,
    rx: 0.5,
    strokeWidth: 1.5,
    width: 22.855986,
    x: 75.136334,
    y: 117.809621
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m81.9975796 107.95393h9.1334947v10.555555h-9.1334947z",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.9975796 87.4661247h9.1334947v18.5636853h-9.1334947z",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.9975796 66.9783198h9.1334947v18.5636855h-9.1334947z",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.9975796 46.4905149h9.1334947v18.5636856h-9.1334947z",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.9975796 27.4254743h9.1334947v4.4444444h-9.1334947z",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.9975796 0 9.1334947 8.34688347v17.45257453h-9.1334947z",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.99758 0-25.117111 19.728997",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.99758 0 45.667473 19.728997",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.99758 0-61.65109 19.728997",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.309067 19.7289973h24.355986v6.0704607h-31.2061068z",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.07335692 27.7777778h6.68702288v2.8333333c0 .2761424-.2238576.5-.5.5h-5.68702288c-.27614238 0-.5-.2238576-.5-.5z",
    strokeLinecap: "square",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 13.902439,
    rx: 0.5,
    strokeLinecap: "square",
    strokeWidth: 2,
    width: 13.700242,
    x: 127.665053,
    y: 17.452575
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.175573 41.151762h-18.191175",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(334 52)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#a)",
    height: 1.714286,
    rx: 0.3,
    stroke: "#000",
    strokeWidth: 0.5,
    width: 16.136388
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.3 0h15.5363883c.1656854 0 .3.13431458.3.3v15.1714286c0 .1656854-.1343146.3-.3.3h-15.5363883c-.16568542 0-.3-.1343146-.3-.3v-15.1714286c0-.16568542.13431458-.3.3-.3z",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.07892256 12.4820779h11.83465594c.1466808 0 .2655892-.1079168.2655892-.2410389 0-.1331222-.1189084-.241039-.2655892-.241039h-11.83465594c-.14668088 0-.26558923.1079168-.26558923.241039 0 .1331221.11890835.2410389.26558923.2410389z",
    fill: "#000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.07892256 14.0820779h6.52287138c.14668088 0 .26558922-.1079168.26558922-.2410389 0-.1331222-.11890834-.241039-.26558922-.241039h-6.52287138c-.14668088 0-.26558923.1079168-.26558923.241039 0 .1331221.11890835.2410389.26558923.2410389z",
    fill: "#000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.136388 1.728899h-16.136388",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.794339,
    cy: 0.915299,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.62612,
    cy: 0.915299,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.457901,
    cy: 0.915299,
    rx: 1,
    ry: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.7ddd6177e74afdf128eb18818073df86.svg";
export { ForwardRef as ReactComponent };